import React from "react";
import "./styles/ownProductShow.css";
import Button from "react-bulma-components/lib/components/button";
import {Redirect} from "react-router-dom";
import agent from '../../api/agent'
import Modal from "react-bulma-components/lib/components/modal";
import moment from "moment";
import {inject, observer} from "mobx-react";
import ShareMenu from '../../helpers/shareTheUrl'
import 'react-toastify/dist/ReactToastify.css';
import {toast} from 'react-toastify';
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import PinchToZoom from "react-pinch-and-zoom";
import OpenConfModal from '../errorHandling/errorModal';
import OB1 from '../Home/onboarding/onboarding1-modal'
import OB2 from '../Home/onboarding/onboarding2-modal'
import OB3 from '../Home/onboarding/onboarding3-modal';
import ArtworkNotAvailable from './artwork-not-available';
import ReactGA from "react-ga";
import {
    validateIfInputHasCharacters,
    validateIfInputHasSpaces,
    validateIfInputHasUpperCaseLetter,
    validateIfInputHasYourMasterpieces,
    validateInputLength
} from "../../helpers/validationChecks";
// var artworks_url_list1 = [
//     { Imgurl: require('../../assets/artwork_picture.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "200" },

//     { Imgurl: require('../../assets/painting1.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "300" },
//     { Imgurl: require('../../assets/painting2.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "400" },
//     { Imgurl: require('../../assets/painting3.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "100" },
// ]
@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'likeAndUnlikeStore', 'requestsStore')
@observer
export default class ownProductShow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // localLiked: false,
            actualLiked: false,
            placedRequestDone: false,
            wantsToBuy: false,
            artworkClicked: false,
            wantsToViewProfile: false,
            artistClicked: false,
            fullScreenImage: false,
            currentImageToPreview: false,
            wantsToEdit: false,
            wantToDeleteArtwork: false,
            reportBody: {
                report_type: 0,
                // customReportReason : ""
            }
        }

    }
    static contextTypes = {
        router: () => true, // replace with PropTypes.object if you use them
    }
    handleLikeClick(id) {
        var str = id;
        (!localStorage.hasOwnProperty("userData")) ? this.props.navigatorStore.openSignInModal() :
            (!this.state.actualLiked) ?
                this.setState({
                    actualLiked: !this.state.actualLiked,
                    likes_received: this.state.likes_received + (!this.state.actualLiked ? +1 : -1),
                    likeInProcess: true
                }, () => {
                    (localStorage.hasOwnProperty("userData")) ?
                        this.props.likeAndUnlikeStore.likeTheArtwork(str)
                            .then((res) => {
                                toast("This artwork was added to your collection!")
                                // console.log(res)
                                this.props.artworksStore.getArtworkDetailsPublicAuth(str, null, true)
                                    .then((resp) => {
                                        // console.log("this is artwork data", resp);
                                        this.setState({
                                            likeInProcess: false,
                                            // actualLiked: resp.data.data[0].artwork.liked,                                       
                                            // likes_received: resp.data.data[0].artwork.total_likes_received,                                       
                                        }, function () {
                                            // console.log(resp, this.state.artworkData)
                                        })
                                    })
                                    .catch((err) => {
                                        // console.log("Something went wrong. Please try again.");
                                        return
                                    })
                            })
                        : this.props.navigatorStore.openSignInModal()
                })
                : this.props.navigatorStore.openErrorModal("Are you sure you want to remove this artwork from your collection?", true, str)

    }

    handleConfirmModalAction(actionInfo, id) {

        // console.log("handling modal action ", actionInfo, id)
        let item = this.state[id]
        // console.log("handling modal action ", item)
        actionInfo ?
            this.setState({
                actualLiked: !this.state.actualLiked,
                likes_received: this.state.likes_received + (!this.state.actualLiked ? +1 : -1),
                likeInProcess: true
            }, () => {
                this.props.likeAndUnlikeStore.unLikeTheArtwork(id)
                    .then((res) => {
                        // console.log(res)
                        this.props.artworksStore.getArtworkDetailsPublicAuth(id, null, true)
                            .then((resp) => {
                                toast("This artwork was removed from your collection!")
                                // console.log("this is artwork data", resp);
                                this.setState({
                                    likeInProcess: false,
                                    // actualLiked: resp.data.data[0].artwork.liked,
                                    // likes_received: resp.data.data[0].artwork.total_likes_received,
                                }, function () {
                                    // console.log(resp, this.state.artworkData)
                                })
                            })
                            .catch((err) => {
                                // console.log("Something went wrong. Please try again.");
                                return
                            })
                    })
            })
            : ""
    }

    handleArtworkClick() {
        this.setState({
            artworkClicked: !this.state.artworkClicked
        })
    }

    handleBuyRequestBtn() {

        var str = this.props.match.params.id;
        if (this.state.myOwnArtwork) {
            (!localStorage.hasOwnProperty("userData")) ? this.props.navigatorStore.openSignInModal() :
                this.props.artworksStore.getArtworkDetailsPrivate(this.state.artworkId)
                    .then((response) => {
                        // console.log(response)
                        if (response.error == "True") {
                            // this.props.navigatorStore.openErrorModal(response.message);
                            return;
                        }
                        else this.setState({
                            wantsToEdit: true
                        })
                    })
        }
        else
            // this.props.requestsStore.artworkBuyRequest(this.state.artworkId)
            // .then((res) => {
            // // console.log(res)
            (!localStorage.hasOwnProperty("userData")) ? this.props.navigatorStore.openSignInModal() :
                this.setState({
                    wantsToBuy: true
                })
        // })




    }
    handleImageCarouselClick(item) {
        this.setState({
            currentImageToPreview: item
        })
    }

    handleViewProfileClick(id) {
        (localStorage.hasOwnProperty("userData")) ?
            this.setState({
                artistClicked: true,
                artistUN: id
            })
            : this.props.navigatorStore.openSignInModal()


    }
    fullScreenImage() {
        this.setState({
            fullScreenImage: true
        }, () => {
            ReactGA.pageview('/Full screen');
        })
    }
    onCloseFullScreenImage() {
        this.setState({
            fullScreenImage: false
        })
    }


    loadArtworkData(id, publicAPI) {
        agent.Artworks[publicAPI ? "getArtworkDetailsPublicAuthNoMessage" : "getArtworkDetailsPublicAuthNoMessagePrivate"](id)
            .then((resp) => {
                if (resp) {

                    /* empty page design in case of inactive painting */

                    if (resp.error == "True") {
                        this.setState({
                            deleted: true
                        })
                        return;
                    }
                    else {
                        var ds = resp.data.data[0].artwork.created_at
                        var date = moment(new Date(ds.substr(0, 16)));
                        var dateF = date.format("DD MMMM YYYY")

                        // console.log("this is artwork data", resp);
                        this.setState({
                            artworkId: resp.data.data[0].artwork.id,
                            artworkData: resp.data.data[0].artwork,
                            currentImageToPreview: resp.data.data[0].artwork.img1,
                            actualLiked: resp.data.data[0].artwork.liked,
                            buyRequestDone: resp.data.data[0].artwork.br_sent,
                            myOwnArtwork: (resp.data.data[0].artwork.user_profile.id == (localStorage.getItem("profile_id"))),
                            uploaded_on: dateF,
                            likes_received: resp.data.data[0].artwork.total_likes_received,

                            // number  : "31.1234"
                        }, function () {
                            // console.log(resp, this.state.buyRequestDone)
                        })
                    }
                }
                else {
                    this.setState({
                        deleted: true
                    })
                    return;
                }
            })
            .catch((err) => {
                // this.props.navigatorStore.openErrorModal(err);
                return
            })

    }
    componentWillReceiveProps(nextProps) {

        // console.log('[componentWillReceiveProps] srchpage ', nextProps.match.params.id)
        var searchableString = nextProps.match.params.id;

        // console.log({ matcher: searchableString != this.props.match.params.id, })
        if (searchableString != this.props.match.params.id) {
            if (localStorage.hasOwnProperty("userData")) {
                this.loadArtworkData(nextProps.match.params.id)
                return
            }
        }
        else setTimeout(() => {
            var str = nextProps.match.params.id;
            // // console.log('[mounted] componentWillReceiveProps srchpage nextProps ', { nextProps }, nextProps.commonStore.token, nextProps.userStore.loginDone, this.state.artistId, str, this.props.match.params.id)
            // debugger;
            // console.log('[mounted] componentWillReceiveProps srchpage nextProps ', this.state.shareUrl, this.props.userStore.loginDone)
            // if (this.state.shareUrl || str != this.state.artistId) {
            if (this.state.shareUrl && (!!this.props.authStore.loginDone || this.props.authStore.RegisterSuccess)) {
                this.props.authStore.resetLoginDone()
                this.setState({
                    shareUrl: false,
                    artworkId: str
                }, () => {
                    // console.log('[mounted] srchpage next', nextProps.match.params.id)
                    if (localStorage.hasOwnProperty("userData")) {
                        this.loadArtworkData(str);
                        if (this.props.authStore.onboardingThreeIncomplete || this.props.authStore.onboardingTwoIncomplete) {
                            // console.log("hihi tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();

                        }
                        else if (this.props.authStore.RegisterSuccess || localStorage.getItem("just_registered")) {
                            localStorage.removeItem("just_registered");
                            this.props.navigatorStore.openOB1Modal();

                        }
                    }
                })
            }
        }, 1000)


        // document.addEventListener('scroll', this.trackScrolling);

    }
    componentDidMount() {
        // console.log("mounted profile", this.props.match.params.id)
        var str = this.props.match.params.id;

        if (!window.localStorage.hasOwnProperty("userData")) {

            this.setState({ shareUrl: true }, () => {
                // this.props.navigatorStore.openSignInModal()
                this.loadArtworkData(str, true)


            })
        }
        else {
            this.loadArtworkData(str)
            this.props.userStore.pulluser().then((result) => {
                // console.log("{this is pulled user}", result)
                if (!result.data[0].display_name && !!result.data[0].old_display_name) {
                    if ((result.data[0].old_display_name) && !validateInputLength(result.data[0].old_display_name, 6, 30)) {
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && !validateIfInputHasSpaces(result.data[0].old_display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasCharacters(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasUpperCaseLetter(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].old_display_name) && validateIfInputHasYourMasterpieces(result.data[0].old_display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    var formData = new FormData();
                    formData.append("display_name", this.state.formInputs && this.state.formInputs.display_name)
                    // if (!!this.state.formInputs.display_name && (this.state.curr_display_name != this.state.formInputs.display_name))
                    this.props.userStore.validateDisplayName(formData)
                        .then((response) => {
                            // console.log(response)
                            if (response.error == "True") {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true,
                                    // formInputs: { ...this.state.formInputs, display_name: "" }
                                })
                                // this.props.navigatorStore.openErrorModal(response.data)
                                return;
                            }
                            else {
                                // console.log("tell i am coming here at leats")
                                this.props.navigatorStore.openOB3Modal();
                                this.setState({
                                    onboardingThreeIncomplete: true
                                })
                            }
                        })
                        .catch((err => {
                            // console.log("tell i am coming here at leats")
                            this.props.navigatorStore.openOB3Modal();
                            this.setState({
                                onboardingThreeIncomplete: true,



                            })
                        }));
                }

                if (result.data[0].display_name) {
                    if ((result.data[0].display_name) && !validateInputLength(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username should contain 6-30 characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && !validateIfInputHasSpaces(result.data[0].display_name, 6, 30)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain spaces")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasCharacters(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain characters");
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasUpperCaseLetter(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain an uppercase letter")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                    if ((result.data[0].display_name) && validateIfInputHasYourMasterpieces(result.data[0].display_name)) {
                        // this.props.navigatorStore.openErrorModal("username can not contain yourmasterpieces in it")
                        // console.log("tell i am coming here at leats")
                        this.props.navigatorStore.openOB3Modal();
                        this.setState({
                            onboardingThreeIncomplete: true
                        })
                        return;
                    }
                }

                if (!result.data[0].full_name ||
                    !result.data[0].country ||
                    //  !response.data.user_profile[0].full_name || 
                    //  !response.data.user_profile[0].user.email || 
                    //  !response.data.user_profile[0].display_name || 
                    !result.data[0].display_name ||
                    result.data[0].display_name.length >= 30 ||
                    !result.data[0].primary_email ||
                    !result.data[0].preferred_currency

                ) {
                    // console.log("profile null")
                    // console.log("tell i am coming here at leats")
                    this.props.navigatorStore.openOB3Modal();
                    this.setState({
                        onboardingThreeIncomplete: true
                    })
                    // this.state.makeOnboardingThreeIncomplete()
                }

            })

        }



    }


    handleReportModal() {

        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        (this.state.myOwnArtwork) ?
            this.setState({
                wantToDeleteArtwork: true
            },
                agent.Artworks.deleteArtwork(this.state.artworkId)
                    .then((res) => {
                        if (res.err == "True") {
                            // this.props.navigatorStore.openErrorModal(res.data)
                            return;
                        }
                        else {
                            // window.history.go(-1)
                           this.props.history.replace(`/profile/details/${localStorage.getItem("username")}`)
                           window.location.reload();
                        }
                    })
                //  this.props.navigatorStore.openErrorModal("Are you sure you want to delete this artwork?")
            )
            :
            this.setState({
                reportModalOpen: true
            }
            )
    }
    closeReportModal() {
        this.setState({

            reportModalOpen: false
        })
    }

    handleReportArtwork() {

        this.props.artworksStore.reportArtwork(this.state.artworkId, this.state.reportBody)
            .then((res) => {
                this.setState({
                    reportedThisArtwork: true
                })
            })


    }

    handleReasonSelect(reportType) {
        this.setState({
            reportBody: {
                ...this.state.reportBody,
                report_type: reportType
            }
        }, function () {
            // console.log(this.state.reportBody)
        })
    }

    handleCustomReportReason(e) {
        this.setState({
            reportBody: {
                ...this.state.reportBody,
                additional_details: e.target.value
            }
        })
    }

    handleShareButton() {

        if (!window.localStorage.hasOwnProperty("userData")) {

        }
    }
    figuredOutMediumAndBase(stringToEdit) {
        if (!!stringToEdit) {
            var removedOthers = stringToEdit.replace(", Others", "");
             removedOthers = removedOthers.replace("Others ,", "");
             removedOthers = removedOthers.replace("Others", "");
            var removedComma = removedOthers.replace(", ,", ",");
            // console.log("got it stringToEdit",
            // {stringToEdit:stringToEdit,removedComma:removedComma,removedOthers:removedOthers})
            if (removedComma.charAt(0) == ",") {
                removedComma = removedComma.substr(1, removedComma.length)
            }
        }
        return removedComma
    }
    figuredOutCustomMediumAndBase(stringToEdit){
      var removedComma;
        if ( !!stringToEdit && stringToEdit.charAt(0) == ",") {
            removedComma = stringToEdit.substr(1, stringToEdit.length)
        }
        return removedComma
    }
    render() {


        if (this.state.deleted) {
            return (
                <ArtworkNotAvailable/>
            )
        };

        const ReportReasons = [
            {
                value: 1, display: "It is my artwork"
            },
            {
                value: 2, display: "Inappropriate/disturbing content"
            },
            {
                value: 3, display: "Mature content"
            },
            {
                value: 4, display: "Not original"
            },
            {
                value: 5, display: "Others"
            },
        ]


        const imagesPath = {
            unchecked: require('../../assets/unchecked.png'),
            checked: require('../../assets/checked.png')
        }
        const imageList = [
            { url: (this.state.artworkData) ? this.state.artworkData.img1 : "" },
            { url: (this.state.artworkData) ? this.state.artworkData.img2 : "" },
            { url: (this.state.artworkData) ? this.state.artworkData.img3 : "" }
        ]
        // console.log("[imageList]", imageList)

        // if (this.state.artistClicked) {
        //     return (
        //         <Redirect push to={`/product/details/${this.state.artistUN}`}>

        //         </Redirect>
        //     )
        // }
        if (this.state.reportedThisArtwork) {
            return (
                <Redirect push to="/artwork-not-available">

                </Redirect>
            )
        }

        if (this.state.wantsToEdit) {
            return (
                <Redirect push to={{ pathname: `/uploadimage2/${this.state.artworkData.id}` }}>

                </Redirect>
            )
        }
        if (this.state.artistClicked) {
            return (
                <Redirect push to={`/profile/details/${this.state.artistUN}`}>

                </Redirect>
            )
        }

        if (this.state.wantsToBuy) {
            return (
                <Redirect push to={`/place-buy-request/${this.state.artworkId}`} />
            )
        }


        // if (this.state.wantsToViewProfile) {
        //     return (
        //         this.props.history.replace(this.state.clickedArtistId)
        //     )
        // };

        var date = (this.state.artworkData) ? this.state.artworkData.updated_at : "";

        var res = "";
        if (this.state.artworkData) {
            var figuredOutMedium = this.figuredOutMediumAndBase(this.state.artworkData.medium);
            var figuredOutBase = this.figuredOutMediumAndBase(this.state.artworkData.base);
            // var figuredOutCustomMedium = this.figuredOutCustomMediumAndBase(this.state.artworkData.custom_medium);
            // var figuredOutCustomBase = this.figuredOutCustomMediumAndBase(this.state.artworkData.custom_base);
        }
        return (
            (this.state.artworkData) ?
                <div className="product-details-page-container">
                    <div className="product-details-container">
                        <div className="breadcrumbs-details">
                            {/* <Button onClick={this.context.router.history.goBack}>>Return</Button> */}
                            {/* Artwork / Watercolor / Artwork name */}
                        </div>
                        <OB3 />
                        <OB2 />
                        <OB1 />
                        <div className="product-details">
                            <div className="product-details-product-images">
                                <div className="product-details-image-preview-window">
                                    <div className="product-details-big-preview" onClick={this.fullScreenImage.bind(this)}>
                                        {/* <ReactImageZoom {..._props} /> */}
                                        <img
                                            style={{
                                                maxHeight: "70vh",
                                                maxWidth: "auto"
                                            }}
                                            className="preview-image" src={this.state.currentImageToPreview} />
                                    </div>
                                    <Modal className="full-preview-image" show={this.state.fullScreenImage} onClose={this.onCloseFullScreenImage.bind(this)} >
                                        <img onClick={this.onCloseFullScreenImage.bind(this)} className="cross-icon-for-fullscreen-image-modal" src={require('../../assets/cross_icon_for_close.png')}></img>
                                        <Modal.Content style={{ width: "auto" }}>
                                            <PinchToZoom>
                                                <img className="fullscreen-image" src={this.state.currentImageToPreview} />
                                            </PinchToZoom>
                                        </Modal.Content>
                                    </Modal>
                                    <div style={{ display: "flex" }}>

                                        <div style={{ flex: 1 }} className="product-details-list-preview">
                                            <ImagePreviewWindow imageList={imageList} handleImageCarouselClick={this.handleImageCarouselClick.bind(this)} />
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div className="product-details-product-data">
                                <div className="product-details-product-name">
                                    {(this.state.artworkData.title) ? this.state.artworkData.title : this.state.artworkData.old_title}
                                </div>


                                <div className="product-details-product-cost">
                                    {
                                        this.state.artworkData.wish_to_sell ?
                                            <div className="product-details-product-cost">

                                                <p className="price-text" >

                                                    <p className="price-text"
                                                    // style={{ display: (this.state.artworkData.wish_to_sell || this.state.artworkData.old_seller_price==0) ? "" : "none" }}
                                                    >
                                                        {
                                                            (!this.state.artworkData.seller_price && !this.state.artworkData.old_seller_price) ? <p style={{
                                                                // display: (this.state.artworkData.wish_to_sell  || this.state.artworkData.old_seller_price==0) ? "none" : "",
                                                                fontSize: "25px", coolor: "#666666", fontWeight: "300"
                                                            }}> Not For Sale </p> :
                                                                (!localStorage.hasOwnProperty("preferred_currency")) ?
                                                                    this.state.artworkData.seller_price ?

                                                                        this.state.artworkData.currency_code.toUpperCase() + ` ` + this.state.artworkData.product_base_price :

                                                                        this.state.artworkData.currency_code.toUpperCase() + ` ` + Math.round(this.state.artworkData.old_seller_price * 10) / 10 :

                                                                    localStorage.getItem("preferred_currency").toUpperCase() + ` ` + Math.round(this.state.artworkData[`${localStorage.getItem("preferred_currency").toLowerCase()}_price`] * 10) / 10

                                                        }*</p>
                                                    <p className="cost-terms-and-conds" style={{ display: (this.state.artworkData.wish_to_sell) ? "" : "none" }}>
                                                        * shipping and handling charges extra
                                                    </p>
                                                </p>

                                            </div>
                                            :
                                            <p style={{
                                                // display: (this.state.artworkData.wish_to_sell  || this.state.artworkData.old_seller_price==0) ? "none" : "",
                                                fontSize: "25px", coolor: "#666666", fontWeight: "300"
                                            }}> Not For Sale </p>
                                    }
                                </div>


                                <div className="artwork-buy-request-and-likes">
                                    <div className="artwork-buy-request-btn">
                                        <BuyRequestButton myOwnArtwork={this.state.myOwnArtwork} handleBuyRequestBtn={this.handleBuyRequestBtn.bind(this)} buyRequestDone={this.state.buyRequestDone} />
                                        {/* <EditArtworkButton /> */}
                                    </div>
                                    <div className="artwork-likes-and-like-btn">
                                        <div className="artworks-likes" onClick={(this.state.likeInProcess) ? "" : () => this.handleLikeClick(this.state.artworkData.id)} style={{ cursor: "pointer" }}>
                                            <img className="artwork-likes-icon" src={(this.state.actualLiked) ? require('../../assets/heart_filled@2x.png') : require('../../assets/black_heart_png.png')} />
                                            <p className="like-number">{this.state.likes_received} </p>
                                        </div>
                                        <OpenConfModal handleActions={this.handleConfirmModalAction.bind(this)} />
                                        <div className="artwork-like-btn" style={{ flex: "unset" }}>
                                            <UncontrolledDropdown nav inNavbar>
                                                <DropdownToggle nav caret>
                                                    <Button className="masterpieces-secondary-buttons share-button"
                                                        onClick={() => this.handleShareButton(this.state.artworkData.share_url)}
                                                    >SHARE</Button>
                                                </DropdownToggle>
                                                <ShareMenu share_url={this.state.artworkData.share_url} />
                                            </UncontrolledDropdown>
                                        </div>
                                        <UncontrolledDropdown nav inNavbar reportArtworkBlock>
                                            <DropdownToggle nav caret>
                                                <Button className="masterpieces-secondary-buttons report-btn"><img className="dropdown-arrow" src={require('../../assets/down_arrow.png')}></img></Button>
                                            </DropdownToggle>
                                            <DropdownMenu className="notificationDropdown">
                                                <DropdownItem onClick={this.handleReportModal.bind(this)}>
                                                    {(this.state.myOwnArtwork) ? "DELETE ARTWORK" : "REPORT ARTWORK"}
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>
                                </div>
                                <Modal show={this.state.reportModalOpen} onClose={this.closeReportModal.bind(this)} >

                                    <Modal.Content>
                                        <div className="masterpieces-modal-header pt-20 pb-25 pl-25">
                                            <p className="masterpieces-modal-heading">Report artwork
                                                <img onClick={this.closeReportModal.bind(this)}
                                                    className="cross-icon-for-masterpieces-modal"
                                                    src={require('../../assets/cross_icon_for_close.png')}></img>
                                            </p>

                                        </div>
                                        <div className="report-artwork-content pt5 pl-25">

                                            <p className="please-choose-a-reas mb-15">Please choose a reason for
                                                reporting the
                                                artwork</p>

                                            <div className="filter-price-checkboxes mt-15">
                                                {
                                                    ReportReasons.map((el, idx) => (
                                                        < div className="filters-list-container report-block">
                                                            <img onClick={() => this.handleReasonSelect(el.value)} alt="" className="filters-checkbox"
                                                                src={
                                                                    (this.state.reportBody.report_type == el.value) ?
                                                                        imagesPath.checked : imagesPath.unchecked} />
                                                            <p className="report-label-name">{el.display}</p>
                                                        </div>
                                                    )
                                                    )
                                                }

                                                <div className="form-group mt-25"
                                                    style={{ display: this.state.reportBody.report_type == 5 ? "" : "none" }}
                                                >
                                                    <label htmlFor="from-price">TYPE YOUR OWN</label>
                                                    <textarea name="report-bio" onChange={this.handleCustomReportReason.bind(this)}
                                                        name="additional_details"
                                                        className="form-element-large-input-profile-details bge6 mb-15">
                                                    </textarea>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="report-footer">
                                            <button onClick={this.handleReportArtwork.bind(this)} className="masterpieces-primary-buttons btn-primary report-button pull-right">Report
                                            </button>
                                        </div>

                                    </Modal.Content>
                                </Modal>
                                <div className="product-details-artwork-data">
                                    {
                                        (this.state.artworkData.base) ?
                                            <div>
                                                {/* <hr className="artwork-details-horizontal-rule"></hr> */}
                                                <div className="product-details-artwork-dimensions-year-technique">
                                                    <p className="product-details-artwork-title">MEDIUM</p>
                                                    <p className="product-details-artwork-value">{figuredOutMedium


                                                    }{
                                                        // figuredOutCustomMedium
                                                        !!this.state.artworkData.custom_medium ? !!figuredOutMedium  ? `, ${this.state.artworkData.custom_medium}` : this.state.artworkData.custom_medium : ""
                                                    }
                                                        </p>
                                                </div>
                                                <hr className="artwork-details-horizontal-rule"></hr>
                                                <div className="product-details-artwork-dimensions-year-technique">
                                                    <p className="product-details-artwork-title">BASE</p>
                                                    <p className="product-details-artwork-value">{figuredOutBase
                                                    }{
                                                        // figuredOutCustomBase
                                                        !!this.state.artworkData.custom_base ? !!figuredOutBase  ? `, ${this.state.artworkData.custom_base}` :   this.state.artworkData.custom_base : ""
                                                        }</p>
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                {/* <hr className="artwork-details-horizontal-rule"></hr> */}
                                                <div className="product-details-artwork-dimensions-year-technique">
                                                    <p className="product-details-artwork-title">TECHNIQUE</p>
                                                    <p className="product-details-artwork-value">{this.state.artworkData.medium}</p>
                                                </div>
                                            </div>
                                    }
                                    <hr className="artwork-details-horizontal-rule"></hr>
                                    {
                                        /*  localStorage.hasOwnProperty("preferred_dimension") ?
                                             <div className="product-details-artwork-dimensions-year-technique">
                                                 <p className="product-details-artwork-title">DIMENSIONS</p>
                                                 <p className="product-details-artwork-value">{Math.round(this.state.artworkData.base_width * 10) / 10 || 0}
                                                     {` x `}{Math.round(this.state.artworkData.base_height * 10) / 10 || 0}{` x `}
                                                     {Math.round(this.state.artworkData.base_depth * 10) / 10 || 0}{` `}
                                                     {localStorage.getItem("preferred_dimension")}</p>
                                             </div>
                                             : */
                                        (this.state.artworkData.dimension) ?
                                            <div className="product-details-artwork-dimensions-year-technique">
                                                <p className="product-details-artwork-title">DIMENSIONS</p>
                                                <p className="product-details-artwork-value">{Math.round(this.state.artworkData.width * 10) / 10 || 0}
                                                    {` x `}{Math.round(this.state.artworkData.height * 10) / 10 || 0}{` x `}
                                                    {Math.round(this.state.artworkData.depth * 10) / 10 || 0}
                                                    {` `}{this.state.artworkData.dimension.toUpperCase()}</p>
                                            </div>
                                            :
                                            <div className="product-details-artwork-dimensions-year-technique">
                                                <p className="product-details-artwork-title">DIMENSIONS</p>
                                                <p className="product-details-artwork-value">{this.state.artworkData.old_dimension}</p>
                                            </div>
                                    }
                                    <hr className="artwork-details-horizontal-rule" style={{ display: (this.state.artworkData.self_created || !!this.state.artworkData.created_by) ? "" : "none" }}></hr>
                                    <div className="product-details-artwork-dimensions-year-technique" style={{ display: (this.state.artworkData.self_created || !!this.state.artworkData.created_by) ? "" : "none" }}>
                                        <p className="product-details-artwork-title">CREATED BY</p>
                                        <p className="product-details-artwork-value">{(this.state.artworkData.self_created) ?
                                            (this.state.artworkData.user_profile.display_name) ?
                                                this.state.artworkData.user_profile.display_name :
                                                this.state.artworkData.user_profile.old_display_name :
                                            (!!this.state.artworkData.created_by) ? this.state.artworkData.created_by : ""}</p>
                                    </div>
                                    <hr className="artwork-details-horizontal-rule"></hr>
                                    <div className="product-details-artwork-dimensions-year-technique">
                                        <p className="product-details-artwork-title">YEAR</p>
                                        <p className="product-details-artwork-value">{(this.state.artworkData.year) ? this.state.artworkData.year : this.state.artworkData.old_year}</p>
                                    </div>
                                    <hr className="artwork-details-horizontal-rule"></hr>
                                    <div className="product-details-artwork-dimensions-year-technique">
                                        <p className="product-details-artwork-title">UPLOADED ON</p>
                                        <p className="product-details-artwork-value">{
                                            // (this.state.artworkData) ? moment(new Date(this.state.artworkData.updated_at.substr(0, 16))) : "2019-06-08T07:24:20.253837Z"
                                            this.state.uploaded_on

                                        }
                                        </p>
                                    </div>

                                </div>
                                <div className="product-details-artist-profile">
                                    <div className="same-row">
                                        <div className="product-details-artist-profile-picture" style={{ cursor: "pointer" }}>
                                            <img
                                            style={{objectFit : "cover"}}
                                            onClick={() => this.handleViewProfileClick(this.state.artworkData.user_profile.share_url.substr(this.state.artworkData.user_profile.share_url.lastIndexOf("/") + 1))} src={this.state.artworkData.user_profile.image || (this.state.artworkData.user_profile.fb_id && `https://graph.facebook.com/${this.state.artworkData.user_profile.fb_id}/picture?type=large`) || require('../../assets/default_picture.png')} />
                                        </div>
                                        <div className="artist-profile-name-and-location">
                                            <p className="artist-name">{this.state.artworkData.user_profile.full_name}</p>
                                            <hr className="artist-profile-horizontal-rule"></hr>
                                            <p className="artist-location">{this.state.artworkData.user_profile.country}</p>
                                        </div>
                                    </div>{
                                        localStorage.hasOwnProperty("userData") ?
                                            // <a  target="_blank" 
                                            // href={`/profile/details/${this.state.artworkData.user_profile.share_url.substr(this.state.artworkData.user_profile.share_url.lastIndexOf("/") + 1)}`}>
                                            <Button

                                                onClick={() => this.handleViewProfileClick(this.state.artworkData.user_profile.share_url.substr(this.state.artworkData.user_profile.share_url.lastIndexOf("/") + 1))}
                                                id="view-profile-btn" className="masterpieces-secondary-buttons">VIEW PROFILE</Button>
                                            // </a>
                                            :
                                            <Button
                                                onClick={() => this.handleViewProfileClick(this.state.artworkData.user_profile.share_url.substr(this.state.artworkData.user_profile.share_url.lastIndexOf("/") + 1))}
                                                id="view-profile-btn" className="masterpieces-secondary-buttons">VIEW PROFILE</Button>
                                    }
                                </div>
                                <div className="product-details-artwork-story">
                                    <div className="artwork-story-title">The Story</div>
                                    <p className="artwork-story-content">{this.state.artworkData.description || "This artwork has no story"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="rectangle-featured-artworks" ref={this.artworksRef} >
                        <div className="title-featured-artworks" >
                            RELATED ARTWORKS
                    <hr className="line-category-name "></hr>
                        </div>
                        <div className="row mt-15 mb-15 pb-15" style={{ overflowX: "hidden", flexWrap: "nowrap" }}>
                            <div className="scroll-x-block">
                                <Artwork artworkData={this.state.featuredArtworksList} />

                            </div>
                        </div>
                    </div> */}
                </div >
                : <div style={{ minHeight: "-webkit-fill-available" }}></div>
        )
    }
}



const BuyRequestButton = (props) => {
    let { handleBuyRequestBtn, buyRequestDone, myOwnArtwork } = props;
    return ((!myOwnArtwork) ?
        <Button onClick={(!buyRequestDone) ? handleBuyRequestBtn : ""} style={{ flex: 1, cursor: buyRequestDone ? "default" : "pointer" }}
            className={(buyRequestDone) ? "masterpieces-secondary-buttons request-btn" : "masterpieces-primary-buttons request-btn"}>
            <p style={{ color: (buyRequestDone) ? '#333333' : '#FFFFFF' }}> {(buyRequestDone) ? 'BUY REQUEST SENT' : 'SEND BUY REQUEST'}</p>
        </Button>

        :
        <Button onClick={handleBuyRequestBtn} style={{ flex: 1 }}
            className="masterpieces-tertiary-black-button request-btn">
            <p>EDIT ARTWORK INFO</p>
        </Button>
    )
}


const ImagePreviewWindow = (props) => {
    let { imageList, handleImageCarouselClick } = props;

    return (
        (imageList && imageList.length) ? (
            imageList.map(
                (el, elIndex) => (
                    < img key={elIndex} onClick={((el.url) ? () => handleImageCarouselClick(el.url) : "")}
                          className={el.url != null ? 'product-details-list-image' : 'no-display'}
                          src={el.url || require('../../assets/artwork_image.png')}/>
                )
            )
        )
            : <div></div>
    )
}


// WEBPACK FOOTER //
// ./src/components/products/ownProductShow.js